export default __webpack_public_path__ + "static/media/LUX_SEÑALA.54ed996e.png";